import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

import {
  FlowEmailAddFlowPayloadT,
  FlowEmailGetPayloadT,
  FlowEmailUpdateFlowPayloadT,
} from '../api/types';

export const emailFlowActions = createActions(
  {
    EMAIL_FLOW_GET: [
      (payload: FlowEmailGetPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    EMAIL_FLOW_ADD: [
      (payload: FlowEmailAddFlowPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
    EMAIL_FLOW_EDIT: [
      (payload: FlowEmailUpdateFlowPayloadT) => payload, // Payload
      (_payload, resolve = noop, reject = noop) => ({ resolve, reject }), // Meta
    ],
  },

  'EMAIL_FLOW_GET_SUCCEEDED',
  'EMAIL_FLOW_GET_FAILED',

  'EMAIL_FLOW_ADD_SUCCEEDED',
  'EMAIL_FLOW_ADD_FAILED',

  'EMAIL_FLOW_EDIT_SUCCEEDED',
  'EMAIL_FLOW_EDIT_FAILED',

  'EMAIL_FLOW_ADD_NODE',

  'EMAIL_FLOW_BUILD_INIT',

  'EMAIL_FLOW_RESET_STATE',
);
